import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SavedSearchService } from 'src/portal/search-api/services/saved-search.service';

@Component({
  selector: 'save-search',
  templateUrl: './save-search.component.html',
  styleUrls: ['./save-search.component.scss']
})

export class SaveSearchComponent implements OnInit {

  names:string[] = [];
  error: boolean;

  nameFormControl = new FormControl('', [Validators.required,this.nameValidator.bind(this),this.noWhitespaceValidator]);

  constructor(private dialogRef: MatDialogRef<SaveSearchComponent>,private savedSearchService: SavedSearchService,) { }

  ngOnInit(): void {
    this.savedSearchService.getSavedSearches().subscribe(res=>{
      if(res){
       this.names = res.map(x=>x.name)
      }
    })
  }

  save(){
    this.dialogRef.close(this.nameFormControl?.value);
  }


  cancel(){
    this.dialogRef.close();
  }

  private nameValidator(control: FormControl): void {
    if (control.valid) {
      if (this.names.includes(this.nameFormControl?.value.trim())){
            setTimeout(() => {
                control.setErrors({ nameError: true });
            });
        }
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

}

